
const types = {
    set_page_title: 'mbEnterpriseGlobal/set_page_title',
    set_prev_page: 'mbEnterpriseGlobal/set_prev_page',
}

// count state 必須是 Object
const state = {
    pageTitle: null,
    prevPage: null
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_MB_ENTERPRISE_PAGE_TITLE: (state) => {
        return state.pageTitle
    },
    GET_MB_ENTERPRISE_PREV_PAGE: (state) => {
        return state.prevPage
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    setMbEnterprisePageTitle ( {commit}, data ) {
        commit(types.set_page_title, data)
    },
    setMbPrevPage ( {commit}, data ) {
        commit(types.set_prev_page, data)
    },
}

// mutations
const mutations = {
    [types.set_page_title](state, data){
        state.pageTitle = data
    },
    [types.set_prev_page](state, data){
        state.prevPage = data
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/mb/enterprise/global.js